import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";

@customElement("api-docs-errors")
export class ApiDocsErrors extends BaseElement {
    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    render() {
        return html`
            <section class="space-y-4">
                <h2 class="text-2xl font-bold">Errors</h2>
                <p>The API returns errors as JSON with an <code>error</code> field describing the problem.</p>

                <api-docs-code-block
                    .code=${`{
  "error": "Invalid or missing 'terms' parameter. Expected a non-empty array of strings."
}`}
                ></api-docs-code-block>

                <h3 class="text-lg font-semibold">Status Codes</h3>
                <div class="overflow-x-auto">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Meaning</th>
                                <th>Common Causes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code class="badge badge-ghost">200</code></td>
                                <td>OK</td>
                                <td>Request succeeded</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">400</code></td>
                                <td>Bad Request</td>
                                <td>Missing or invalid parameters, empty terms array, invalid country/platform, profanity filter</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">401</code></td>
                                <td>Unauthorized</td>
                                <td>Missing or invalid API key</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">402</code></td>
                                <td>Payment Required</td>
                                <td>No active subscription linked to the API key</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">429</code></td>
                                <td>Too Many Requests</td>
                                <td>Rate limit exceeded (60 requests/minute)</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="text-lg font-semibold">Validation Errors (400)</h3>
                <p>The following validation messages may appear for the keyword endpoints:</p>
                <ul class="list-disc list-inside space-y-1 text-base-content/80">
                    <li><code>Invalid or missing 'terms' parameter. Expected a non-empty array of strings.</code></li>
                    <li><code>Too many terms. Maximum is 100 per request.</code></li>
                    <li><code>All terms must be non-empty strings.</code></li>
                    <li><code>Invalid or missing 'country' parameter.</code></li>
                    <li><code>Invalid or missing 'platform' parameter.</code></li>
                    <li><code>Invalid or missing 'term' parameter. Expected a non-empty string.</code></li>
                    <li><code>Profanity is not allowed.</code></li>
                </ul>
            </section>
        `;
    }
}
